var exports = {
  "fj": "reviewCommentItem__aEY4x_",
  "WV": "reviewCommentRow__DlrNHo",
  "Tg": "reviewCommentContent__tKudhF",
  "g3": "reviewCommentAction__b8892O",
};

module.exports = exports;
